import {Pipe, PipeTransform} from '@angular/core';
import {TtdCategory} from '../../target/target.service';

@Pipe({
  name: 'categorySort'
})
export class CategorySortPipe implements PipeTransform {

  transform(categories: TtdCategory[], ...args: unknown[]): TtdCategory[] {
    if (categories === null || categories === undefined) {
      return categories;
    }
    return categories.sort((a, b) => {
      const aName = a.displayName.toLocaleLowerCase();
      const bName = b.displayName.toLocaleLowerCase();
      if (aName < bName) {
        return -1;
      }
      if (aName > bName) {
        return 1;
      }
      return 0;
    });
  }

}
